import { ComponentLoader } from '@bythepixel/component-loader';
import Accordion from '@Components/accordion';
import CardFiltering from '@Components/cardFiltering';
import CustomVideo from '@Components/customVideo';
import Form from '@Components/form';
import Header from '@Components/header';
import Modal from '@Components/modal';
import Slider from '@Components/slider';
import Specs from '@Components/specs';
import Observer from '@Components/observer';

window.globalComponents = new ComponentLoader(document, [
  Accordion,
  CardFiltering,
  CustomVideo,
  Form,
  Header,
  Modal,
  Observer,
  Slider,
  Specs,
]);
